firebird.directive('offsetByPrevElement', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            //This directive takes the height of the previous element,
            //and applies a top margin to the current element equal to that height.
            //
            //Currently used for attendee list to have its top margin based on
            //the height of the attendee controls above it
            scope.$watch(
                function () {
                    return element.prev()[0].offsetHeight;
                },
                function (newHeight) {
                    element.css('top', newHeight);
                }
            );
        }
    };
});
